/* Response Time CSS */

export default theme => ({
    root: {},
    chart: {
      width: '500px',
      margin: '0 auto',
      //height: '300px',
      textAlign: 'center',
    },
    header: {
      height: '40px',
      color: theme.palette.text.secondary
    },
    portletFooter: {
      display: 'flex',
      justifyContent: 'space-between'
    },
    backGrey:{
      backgroundColor:"#525252",
      //minWidth: '30vw'
    },
    backGrey2:{
      backgroundColor:"#5d5d5d",
      marginBottom: "0px !important",
      marginTop: "0px !important",
      padding: "10px"
    },
    backWhite:{
      backgroundColor:"white"
    },
    textWhite:{
      color:"white"
    },
    details: {
      
      padding: '50px',
      flex: '1 100%',
      marginTop: '50px',
      marginBottom: '50px',
      marginRight: '50px',
      marginLeft: '50px'
    },
  
  });
  
  